import { TipConfiguration, TipOptions } from './TipConfiguration';

export class TypeConfiguration {
    /**
     * Betting type abrv
     */
    abrv: string;

    tips: TipConfiguration;
    isMargin: boolean = false;

    sortOrder: number;

    /**
     * Creates new betting type configuration object 
     * @description Configuration is created for specified betting type abrv or taken from tips argument if configuration for provided betting type abrv is not present
     * @param abrv betting type abrv
     * @param tips tips related to betting type
     */
    constructor(abrv: string, tips: string[] = [], sortOrder: number = 9999) {
        this.abrv = abrv.toLowerCase();
        this.sortOrder = sortOrder;

        this.getConfiguration(tips);
    }

    private getConfiguration(inputTips: string[]) {
        switch (this.abrv) {
            case "3way":
            case "european-cards-handicap":
            case "european-handicap-corners":
            case "which-team-wins-the-rest-of-the-match":
            case "overtime-which-team-wins-the-rest":
            case "1x2-incl-overtime":
            case "most-180s":
            case "who-wins-1st-half":
            case "1st-half-which-team-wins-the-rest":
            case "10-minutes-1x2-from-from-to-to":
            case "who-wins-2nd-half":
            case "booking-1x2":
            case "1st-half-booking-1x2":
            case "which-team-will-have-more-corners":
            case "overtime-1x2":
            case "overtime-1st-half-1x2":
            case "1st-half-corner-1x2":
            case "team-with-highest-scoring-inning":
            case "innings-1-to-5th-top-1x2":
            case "team-to-win-more-innings":
            case "2nd-half-1x2-incl-overtime":
            case "most-sixes":
            case "1x2-incl-extra-innings":
            case "who-scores-last":
            case "team-with-highest-scoring-quarter":
            case "most-fours":
            case "most-run-outs":
            case "team-with-highest-scoring-half":
            case "1st-half-try-1x2":
            case "most-catches":
            case "most-extras":
            case "try-1x2":
            case "1st-half-first-team-to-score":
            case "last-team-to-score-try":
            case "most-keeper-catches":
            case "2nd-half-first-team-to-score-try":
            case "first-team-to-score-try":
            case "innings-1-to-5-1x2":
            case "most-stumpings":
            case "setnr-set-gamenrx-and-gamenry-game-winner":
            case "v1-koja-ce-ekipa-dobiti-1-zuti-karton-511":
            case "v1-tko-postize-prvi-gol-u-1-poluvremenu-506":
            case "highest-scoring-half":
            case "competitor1-highest-scoring-half":
            case "competitor2-highest-scoring-half":
            case "head2head-1x2":
            case "setnr-set-which-player-wins-the-rest":
            case "which-player-wins-the-rest-of-the-match":
            case "frames-1-to-framenr-1x2":
            case "inningnr-inning-winner":
            case "inningnr-innings-1x2":
            case "team-with-highest-opening-partnership":
            case "15-minutes-1x2-from-from-to-to":
            case "5-minutes-1x2-from-from-to-to":
            case "race-to-cornernr-corners":
            case "match-time-result-minute":
                this.tips = TipConfiguration.get({ configName: "3way" });
                break;
            case "1st-half-handicap-hcp":
            case "2nd-half-handicap-hcp":
            case "handicap-hcp":
            case "1st-half-try-handicap-hcp":
            case "handicap-hcp-incl-extra-innings":
            case "map-handicap-hcp":
            case "periodnr-period-handicap-hcp":
            case "quarternr-quarter-handicap-hcp":
            case "set-handicap-hcp":
            case "setnr-set-handicap-hcp":
            case "try-handicap-hcp":
                this.tips = TipConfiguration.get({ configName: "3wayMargin" });
                this.isMargin = true;
                break;
            case "quarternr-quarter-1x2":
            case "who-wins-period-periodnr":
            case "inningnr-inning-1x2":
                this.tips = TipConfiguration.get({ configName: "3wayMargin" });
                break;
            case "tip-1x2-and-over-under":
                this.tips = TipConfiguration.get({ configName: "3wayOverUnderMargin" });
                this.isMargin = true;
                break;
            case "1st-half-tip1x2-over-under":
                this.tips = TipConfiguration.get({ configName: "3wayOverUnder" });
                this.isMargin = true;
                break;
            case "3-way-both-teams-to-score":
            case "1st-half-tip-1x2-both-teams-to-score":
            case "1x2-both-teams-to-score-incl-overtime-and-penalties":
            case "2nd-half-1x2-both-teams-to-score":
                this.tips = TipConfiguration.get({ configName: "3wayAndYesNo" });
                break;
            case "double-chance":
            case "1st-half-double-chance":
            case "2nd-half-double-chance":
            case "1st-half-try-double-chance":
            case "overtime-double-chance":
            case "try-double-chance":
            case "periodnr-period-double-chance":
                this.tips = TipConfiguration.get({ configName: "doubleChance" });
                break;
            case "winner":
            case "draw-no-bet":
            case "1st-half-draw-no-bet":
            case "winner-incl-extra-innings":
            case "v1-1st-half-2way-125":
            case "winner-incl-overtime":
            case "winner-incl-super-over":
            case "penalty-shootout-winner":
            case "which-team-kicks-off":
            case "to-qualify":
            case "winner-incl-overtime-and-penalties":
            case "2nd-half-draw-no-bet":
            case "2nd-half-draw-no-bet-incl-overtime":
            case "which-team-has-the-first-attack":
            case "race-to-goalnr-goals-incl-overtime":
            case "v1-tko-prolazi-dalje-500":
            case "v1-duel-strijelaca-528":
            case "v1-hednicap-gamova-u-mecu-523":
            case "head2head":
            case "setnr-set-leg-legnr-winner":
            case "framenr-frame-race-to-pointnr-points":
            case "framenr-frame-player-to-pot-last-ball":
            case "framenr-frame-player-to-pot-xth-ball":
            case "framenr-frame-player-with-highest-break":
            case "race-to-framenr-frames":
            case "try-draw-no-bet":
            case "race-to-pointnr-points-incl-overtime":
            case "setnr-set-game-gamenr-pointnr-point":
            case "setnr-set-race-to-games-games":
            case "setnr-set-tiebreak-winner":
            case "periodnr-period-draw-no-bet":
            case "periodnr-period-handicap":
            case "overtime-draw-no-bet":
                this.tips = TipConfiguration.get({ configName: "winner" });
                break;
            case "setnr-set-winner":
                this.tips = TipConfiguration.get({ configName: "winnerWithSet" })
                break;
            case "gamenr-set-winner":
                this.tips = TipConfiguration.get({ configName: "winnerWithGame" })
                break;
            case "framenr-frame-winner":
                this.tips = TipConfiguration.get({ configName: "winnerWithFrame" })
                break;
            case "goalnr-goal":
            case "goalnr-goal2":
            case "1st-half-goalnr-goal":
            case "1st-half-goalnr-goal2":
            case "2nd-half-goalnr-goal":
            case "overtime-goalnr-goal":
            case "penalty-shootout-goalnr-goal":
            case "last-goal":
            case "last-corner":
            case "1st-half-last-corner":
            case "first-team-to-score":
            case "next-carded-team":
            case "cornernr-corner":
            case "last-team-to-score":
            case "1st-period-first-team-to-score":
                this.tips = TipConfiguration.get({ configName: "winnerNone" });
                break;
            case "which-team-wins-the-coin-toss-and-the-match":
            case "race-to-pointnr-points-incl-overtime":
            case "quarternr-quarter-race-to-pointnr-points-with-none":
            case "1st-half-race-to-pointnr-points":
            case "2nd-half-race-to-pointnr-points-incl-overtime":
                this.tips = TipConfiguration.get({ configName: "winnerNeither" });
                break;
            case "winner-total-incl-overtime":
            case "winner-total":
                this.tips = TipConfiguration.get({ configName: "winnerOverUnder" });
                break;
            case "over-under":
            case "over-under-home-team":
            case "over-under-away-team":
            case "total-incl-overtime":
            case "total-incl-extra-innings":
            case "total-180s":
            case "over-under-games-in-the-match":
            case "1st-half-totals":
            case "1st-half-competitor1-total":
            case "2nd-half-competitor2-total":
            case "2nd-half-competitor1-total":
            case "1st-half-competitor2-total":
            case "2nd-half-over-under":
            case "periodnr-period-total":
            case "setnr-set-over-under":
            case "competitor2-total-incl-overtime":
            case "competitor1-total-incl-overtime":
            case "innings-1-to-5th-top-competitor1-total":
            case "setnr-set-total-games":
            case "competitor1-total-games":
            case "competitor2-total-games":
            case "over-under-corners":
            case "1st-half-over-under-corners":
            case "overtime-total":
            case "2nd-half-total-incl-overtime":
            case "quarternr-quarter-total":
            case "competitor1-total-corners":
            case "competitor2-total-corners":
            case "1st-half-competitor1-total-corners":
            case "1st-half-competitor2-total-corners":
            case "total-bookings":
            case "1st-half-total-bookings":
            case "2nd-half-total-bookings":
            case "competitor1-total-bookings":
            case "competitor2-total-bookings":
            case "1st-half-competitor1-total-bookings":
            case "1st-half-competitor2-total-bookings":
            case "1st-half-total-booking-points":
            case "total-frames":
            case "framenr-frame-total-points":
            case "competitor1-total-180s":
            case "competitor2-total-180s":
            case "v1-vise-manje-gamova-u-1-setu-524":
            case "v1-vise-manje-koseva-527":
            case "inningnr-innings-total":
            case "inningnr-innings-over-overnr-deliverynr-delivery-competitor1-total":
            case "inningnr-innings-competitor1-total":
            case "inningnr-innings-odd-even":
            case "inningnr-inning-total":
            case "inningnr-inning-total-hits":
            case "competitor2-total-tries":
            case "total-tries":
            case "competitor1-total-tries":
            case "quarternr-quarter-competitor1-total":
            case "quarternr-quarter-competitor2-total":
            case "player-total-assists":
            case "player-total-rebounds":
            case "player-total-3-point-field-goals":
            case "player-total-points":
            case "1st-half-competitor2-total-tries":
            case "1st-half-competitor1-total-tries":
            case "player-total-passing-yards":
            case "player-total-rushing-yards":
            case "player-total-receiving-yards":
            case "player-total-rushing-touchdowns-incl-overtime":
            case "setnr-set-leg-legnr-total-darts":
            case "competitor1-total-incl-extra-innings":
            case "competitor2-total-incl-extra-innings":
            case "setnr-set-competitor1-total-games":
            case "setnr-set-competitor2-total-games":
            case "tie-breaks-over-under":
            case "breaks-over-under":
            case "total-sets":
            case "competitor1-breaks-over-under":
            case "competitor2-breaks-over-under":
            case "setnr-set-breaks-over-under":
            case "setnr-set-competitor1-breaks-over-under":
            case "setnr-set-competitor2-breaks-over-under":
            case "inningnr-inning-competitor1-total":
            case "inningnr-inning-competitor2-total":
            case "inningnr-innings-competitor1-total-fours":
            case "inningnr-innings-competitor1-total-sixes":
            case "inningnr-innings-competitor2-total-fours":
            case "inningnr-innings-competitor2-total-sixes":
            case "1st-half-overtime-total":
            case "gamenr-game-total-points":
            case "total-legs-for-setnr-set":
            case "total-legs":
            case "total-points":
            case "competitor1-total-points":
            case "competitor2-total-points":
            case "inningnr-inning-total":
            case "periodnr-period-competitor1-total":
            case "periodnr-period-competitor2-total":
            case "total-incl-overtime-and-penalties":
            case "10-minutes-total-from-from-to-to":
            case "15-minutes-total-from-from-to-to":
            case "5-minutes-total-from-from-to-to":
                this.tips = TipConfiguration.get({ configName: "overUnder" });
                this.isMargin = true;
                break;
            case "total-corners-over-exact-under-total":
                this.tips = TipConfiguration.get({ configName: "overUnderExact" });
                this.isMargin = true;
                break;
            case "1st-half-correct-score":
                this.tips = TipConfiguration.get({ configName: "correctScoreOther", from: 8, to: 8 });
                break;
            case "correct-score-score-max-6":
            case "correct-score-max-4":
                this.tips = TipConfiguration.get({ configName: "correctScoreOther", from: 20, to: 20 });
                break;
            case "frames-1-to-framenr-correct-score":
                this.tips = TipConfiguration.get({ configName: "correctScore", from: 30, to: 30 });
                break;
            case "correct-score":
            case "periodnr-period-correct-score":
                this.tips = TipConfiguration.get({ configName: "correctScoreOther", from: 30, to: 30 });
                break;
            case "setnr-set-correct-score":
                this.tips = TipConfiguration.get({ configName: "correctScoreOther", from: 7, to: 7 });
                break;
            case "setnr-set-game-gamenr-exact-points":
                this.tips = TipConfiguration.get({ configName: "upTo", from: 4, to: 7 });
                break;
            case "1st-half-sending-off":
            case "any-set-to-nil":
            case "1st-half-both-teams-score-a-goal":
            case "2nd-half-both-teams-to-score":
            case "home-team-receives-no-goal":
            case "away-team-receives-no-goal":
            case "both-halves-under-total":
            case "both-halves-over-total":
            case "1st-half-first-try-converted":
            case "player-to-score-incl-overtime":
            case "competitor1-or-any-clean-sheet":
            case "tiebreak-in-match":
            case "any-team-to-miss-a-field-goal":
            case "competitor1-to-score-in-all-periods":
            case "draw-or-any-clean-sheet":
            case "any-team-to-score-a-safety-incl-overtime":
            case "away-team-to-score":
            case "competitor2-to-score-in-all-periods":
            case "2nd-half-first-try-converted":
            case "competitor1-to-win-exactly-1-set":
            case "draw-or-both-teams-to-score":
            case "current-period-either-team-to-score":
            case "first-try-converted":
            case "first-team-to-score-wins-game-yes-no":
            case "bonus-ball-single-digit":
            case "competitor2-to-win-exactly-1-set":
            case "both-teams-to-score-twice":
            case "home-team-to-score":
            case "bonus-ball-equals-any-regular-ball":
            case "match-to-go-to-shootout":
            case "next-away-penalty-scored":
            case "competitor2-or-any-clean-sheet":
            case "any-team-win-to-nil-incl-extra-innings":
            case "will-both-teams-score":
            case "both-teams-to-score-for-periodnr-period":
            case "will-there-be-an-ultra-kill":
            case "will-there-be-a-deciding-frame":
            case "will-there-be-a-tiebreak-in-the-setnr-set":
            case "will-there-be-a-rampage":
            case "will-there-be-a-grand-slam-incl-extra-innings":
            case "will-there-be-a-drop-goal":
            case "will-there-be-a-tie":
            case "will-there-be-a-super-over":
            case "will-there-be-overtime":
            case "will-there-be-overtime":
            case "will-there-be-an-extra-inning":
            case "will-there-be-a-goal-in-overtime":
            case "will-there-be-a-penalty":
            case "will-there-be-a-red-card":
            case "will-there-be-a-5th-set":
            case "will-there-be-a-4th-set":
            case "will-competitor1-win-a-set":
            case "will-competitor2-win-a-set":
            case "competitor1-clean-sheet-incl-overtime-and-penalties":
            case "competitor2-clean-sheet-incl-overtime-and-penalties":
            case "competitor1-to-win-exactly-2-sets":
            case "competitor2-to-win-exactly-2-sets":
            case "competitor1-to-win-all-periods":
            case "competitor2-to-win-all-periods":
            case "competitor1-to-win-any-period":
            case "competitor2-to-win-any-period":
            case "competitor1-to-win":
            case "competitor2-to-win":
            case "competitor1-to-bat-in-9th-inning":
            case "competitor2-to-bat-in-9th-inning":
            case "competitor1-or-both-teams-to-score":
            case "competitor2-or-both-teams-to-score":
            case "competitor1-win-to-nil":
            case "competitor2-win-to-nil":
            case "competitor1-to-win-either-half":
            case "competitor2-to-win-either-half":
            case "competitor1-to-win-both-halves":
            case "competitor2-to-win-both-halves":
            case "competitor1-to-score-in-both-halves":
            case "competitor2-to-score-in-both-halves":
            case "competitor1-sending-off":
            case "competitor2-sending-off":
            case "1st-half-competitor1-sending-off":
            case "1st-half-competitor2-sending-off":
            case "1st-half-competitor1-clean-sheet":
            case "1st-half-competitor2-clean-sheet":
            case "2nd-half-competitor1-clean-sheet":
            case "2nd-half-competitor2-clean-sheet":
            case "2st-half-competitor1-sending-off":
            case "2st-half-competitor2-sending-off":
            case "framenr-frame-competitor1-break-50":
            case "framenr-frame-competitor2-break-50":
            case "framenr-frame-competitor1-break-100":
            case "framenr-frame-competitor2-break-100":
            case "framenr-frame-will-there-be-a-foul-committed":
            case "setnr-set-leg-legnr-any-player-to-score-a-180":
            case "setnr-set-leg-legnr-competitor1-to-score-a-180":
            case "setnr-set-leg-legnr-competitor2-to-score-a-180":
            case "setnr-set-leg-legnr-checkout-score-score":
            case "v1-hoce-li-obe-ekipe-postici-pogodak-u-1-poluvremenu-501":
            case "v1-domacin-postize-barem-1-pogodak-502":
            case "v1-gost-postize-barem-1-pogodak-503":
            case "v1-domacin-postize-pogodak-u-1-poluvremenu-504":
            case "v1-gost-postize-pogodak-u-1-poluvremenu-505":
            case "v1-hoce-li-bilo-koja-ekipa-pobijediti-s-jednim-golom-razlika-507":
            case "v1-hoce-li-bilo-koja-ekipa-pobijediti-s-dva-gola-razlike-508":
            case "v1-hoce-li-bilo-koja-ekipa-pobijediti-s-tri-gola-razlike-509":
            case "v1-hoce-li-biti-penal-na-utakmici-510":
            case "v1-hoce-li-biti-zutog-kartona-izmedju-512":
            case "v1-hoce-li-biti-prekrsaj-izmedju-513":
            case "v1-hoce-li-biti-tie-brake-u-1-setu-525":
            case "v1-hoce-li-biti-tie-brake-u-mecu-526":
            case "competitor1-to-win-exactly-2-setsd":
            case "competitor2-to-win-exactly-2-setsd":
            case "will-the-fight-go-the-distance":
            case "any-team-to-win":
            case "any-team-to-score-a-2-point-conversion-incl-overtime":
            case "next-home-penalty-scored":
            case "competitor1-win-from-behind":
            case "competitor2-win-from-behind":
            case "break-point-in-gamenr-game-in-setnr-set":
            case "match-decided-in-5th-set":
            case "competitor1-to-win-in-straight-sets":
            case "competitor2-to-win-in-straight-sets":
            case "setnr-set-competitor1-to-break-serve":
            case "setnr-set-competitor2-to-break-serve":
            case "inningnr-inning-deliverynr-delivery-competitor1-to-be-a-wicket":
            case "inningnr-inning-deliverynr-delivery-competitor2-to-be-a-wicket":
            case "setnr-set-game-gamenr-to-deuce":
            case "will-game-decided-in-extra-time":
            case "both-teams-to-score-extra-time":
            case "1st-half-competitor1-to-score":
            case "2nd-half-competitor1-to-score":
            case "will-a-red-card-be-shown":
            case "will-a-penalty-be-awarded":
            case "competitor1-to-score":
            case "competitor2-to-score":
            case "triple-double-incl-overtime":
                this.tips = TipConfiguration.get({ configName: "yesNo" });
                break;
            case "both-teams-to-score-over-under":
                this.tips = TipConfiguration.get({ configName: "yesNoOverUnder" });
                this.isMargin = true;
                break;
            case "framenr-frame-break-50":
            case "framenr-frame-break-100":
                this.tips = TipConfiguration.get({ configName: "yesNoWithFrame" })
                break;
            case "handicap":
            case "handicap-incl-overtime":
            case "handicap-incl-extra-innings":
            case "handicap-incl-overtime-and-penalties":
            case "set-handicap":
            case "setnr-set-handicap":
            case "1st-half-handicap":
            case "2nd-half-handicap":
            case "2nd-half-handicap-incl-overtime":
            case "corner-handicap":
            case "1st-half-corner-handicap":
            case "inningnr-inning-handicap":
            case "overtime-1st-half-handicap":
            case "overtime-handicap":
            case "match-game-handicap":
            case "setnr-set-game-handicap":
            case "point-handicap":
            case "frame-handicap":
            case "quarternr-quarter-draw-no-bet":
            case "setnr-set-leg-handicap":
            case "framenr-frame-point-handicap":
            case "overs-0-to-overnr-draw-no-bet":
            case "quarternr-quarter-handicap":
            case "gamenr-game-pointnr-point":
            case "gamenr-game-race-to-pointnr-points":
            case "gamenr-game-point-handicap":
            case "setnr-set-point-handicap":
                this.tips = TipConfiguration.get({ configName: "homeAway" });
                this.isMargin = true;
                break;
            case "frames-fromframe-to-toframe-frames-consecutive-frames-winner":
            case "race-to-pointnr-points-with-none":
            case "race-to-runnr-runs-incl-extra-innings":
            case "next-score-incl-overtime":
            case "1st-half-next-score":
                this.tips = TipConfiguration.get({ configName: "homeNoneAway" });
                break;
            case "odd-even-goals":
            case "1st-half-odd-even":
            case "odd-even-corners":
            case "1st-half-odd-even-corners":
            case "odd-even-incl-overtime":
            case "odd-even":
            case "2nd-half-odd-even":
            case "odd-even-incl-overtime-and-penalties":
            case "odd-even-incl-extra-innings":
            case "odd-even":
            case "2nd-half-odd-even-incl-overtime":
            case "competitor-odd-even-strokes":
            case "odd-even-sets":
            case "runs-odd-even":
            case "1st-half-competitor1-odd-even":
            case "penalty-shootout-competitor2-odd-even":
            case "competitor1-odd-even-incl-overtime":
            case "competitor1-odd-even":
            case "competitor2-odd-even":
            case "2nd-half-competitor2-odd-even":
            case "away-team-runs-odd-even":
            case "odd-even-frames":
            case "bonus-ball-odd-even":
            case "competitor2-odd-even-incl-overtime":
            case "home-team-runs-odd-even":
            case "draw-sum-odd-even":
            case "1st-half-competitor2-odd-even":
            case "bonus-ball-sum-odd-even":
            case "penalty-shootout-odd-even":
            case "2nd-half-competitor1-odd-even":
            case "odd-even-tries":
            case "penalty-shootout-competitor1-odd-even":
            case "odd-even-games":
            case "1st-half-odd-even-tries":
            case "1st-over-odd-even":
            case "quarternr-quarter-odd-even":
            case "setnr-set-odd-even":
            case "framenr-frame-odd-even":
            case "inningnr-innings-over-overnr-competitor1-odd-even":
            case "setnr-set-odd-even-legs":
            case "setnr-set-odd-even-games":
            case "odd-even-points":
            case "1st-half-odd-even-points":
                this.tips = TipConfiguration.get({ configName: "oddEven" });
                break;
            case "halftime-fulltime":
            case "double-result-1st-set-match":
            case "1x2-and-first-team-to-score":
                this.tips = TipConfiguration.get({ configName: "htFt" });
                break;
            case "goalnr-goal-1x2":
                this.tips = TipConfiguration.get({ configName: "htFtNoGoal" });
                break;
            case "double-chance-both-teams-to-score":
            case "2nd-half-double-chance-both-teams-to-score":
            case "double-chance-match-1st-half-both-teams-score":
            case "1st-half-double-chance-both-teams-to-score":
            case "double-chance-match-2nd-half-both-teams-score":
                this.tips = TipConfiguration.get({ configName: "doubleChanceYesNo" });
                break;
            case "1st-2nd-half-both-teams-to-score":
                this.tips = TipConfiguration.get({ configName: "htFtYesNo" });
                break;
            case "total-goals-aggregated":
            case "competitor1-goal-range":
            case "competitor2-goal-range":
                this.tips = TipConfiguration.get({ configName: "goalsAggregated" });
                break;
            case "goals-away-team":
            case "goals-home-team":
                this.tips = TipConfiguration.get({ configName: "upTo", to: 3 });
                break;
            // NOTE: add specific configuration before default
            case "setnr-set-leg-legnr-checkout-colour":
            case "setnr-set-leg-legnr-point-range-on-visitnr-visit":
            case "setnr-set-correct-score-in-legs":
            case "framenr-frame-xth-colour-potted":
            case "framenr-frame-last-points-scored":
            case "framenr-frame-highest-break":
            case "1st-half-winning-margin":
            case "next-scoring-type-incl-overtime":
            case "setnr-set-gamenr-game-number-of-points":
            case "setnr-set-gamenr-game-to-pointnr-score":
            case "inningnr-innings-dismissalnr-dismissal-method":
            case "inningnr-innings-dismissalnr-dismissal-method-limited":
            case "gamenr-game-winning-margin":
            case "winning-margin-exact":
            case "goalnr-goalscorer":
            case "anytime-goalscorer-with-no-goal":
            case "2nd-half-exact-number-of-goals":
            case "1st-half-exact-number-of-goals":
            case "goalnr-goalscorer-with-no-goal":
            default:
                // if betting type is not defined, tips need to be provided and are sorted automatically using .sort() function
                this.tips = new TipConfiguration(inputTips, new TipOptions(true));
                break;
        }
    }
}